import { useState } from "react";
import { InfoList } from "@landtechnologies/components";
import { RecordType } from "react-migration/domains/comparables/typings";
import { formatDate } from "react-migration/domains/comparables";
import { LandTechSection } from "react-migration/domains/comparables/components/Results/Record/LandTechSection";
import { Currency, formatToCurrency, useTranslation } from "react-migration/lib";
import { SupportedLocale } from "src/js/util/dates";
import { userStore } from "src/js/stores/user";
import { MeasurementSystem } from "src/js/stores/user/store";

type ComparablesSearchRecordItemProps = {
  record: RecordType;
  unitPreference: MeasurementSystem;
};

export const ComparablesSearchRecordItem = ({
  record,
  unitPreference,
}: ComparablesSearchRecordItemProps) => {
  const { t } = useTranslation();
  const locale = userStore.locale as SupportedLocale;
  const [isOpen, setOpen] = useState<boolean>(false);

  const soldValue = t("sites.card.comparables_layer.sold_for_price", {
    price: formatToCurrency({
      amount: record.price,
      locale,
      currency: record.currency as Currency,
    }) as string,
  });

  return (
    <InfoList.Item
      className="atlas-cursor-pointer !atlas-px-0 !atlas-py-0"
      data-testid="comparables-overview-search-record-item"
    >
      <div
        className="hover:atlas-bg-background-dark atlas-py-2"
        onClick={() => setOpen(!isOpen)}
        data-testid="comparables-overview-search-record-item-trigger"
      >
        {!isOpen ? (
          <div className="atlas-flex atlas-flex-col">
            <div className="atlas-flex atlas-w-full atlas-justify-between atlas-items-center atlas-gap-x-2">
              <span className="atlas-flex atlas-font-semibold">{soldValue}</span>
              <i className="atlas-flex icon-lt-arrow-down-s-line atlas-text-md" />
            </div>
            <span className="atlas-flex">{record.address}</span>
            <span className="atlas-flex atlas-text-content-placeholder">
              {formatDate(record.date_of_transfer)}
            </span>
          </div>
        ) : (
          <div className="atlas-flex atlas-py-2 atlas-justify-between atlas-items-center">
            <div className="atlas-flex atlas-text-md atlas-font-semibold">{record.address}</div>
            <i className="atlas-flex icon-lt-arrow-up-s-line atlas-text-md" />
          </div>
        )}
      </div>
      {isOpen && (
        <div className={!record.price ? "-atlas-mx-2" : "-atlas-ml-3"}>
          <LandTechSection record={record} unitPreference={unitPreference} locale={locale} />
        </div>
      )}
    </InfoList.Item>
  );
};
